// extracted by mini-css-extract-plugin
export default {"chip":"aAbhpYyb7vMXi7f6eCFM"};